module.exports = {
    GET_ALL_COLLECTIONS_STATS: 'GET_ALL_COLLECTIONS_DETAILS',
    GET_ALL_COLLECTIONS_MAPPING_NAMES: 'GET_ALL_COLLECTIONS_MAPPING_NAMES',
    DELETE_COLLECTION: 'DELETE_COLLECTION',
    CREATE_INDEX: 'CREATE_INDEX',
    DELETE_INDEX: 'DELETE_INDEX',
    FILTER_COLLECTIONS: 'FILTER_COLLECTIONS',
    FILTER_DEFAULT_INDEXES: 'FILTER_DEFAULT_INDEXES'
}
